import authCheckApp from './authCheckApp'

/**
 * 打开新的页面
 * @since 1.0.0
 * @param {Object} obj - 新页面的信息
 * @param {string} obj.url 新页面链接
 * @param {string} obj.title 新页面的标题
 * @param {string} obj.hiddenNavigation 是否显示隐藏导航栏
 * @example
 * 
 *  openNewWebView({
 *     'url': 'http://www.baidu.com',
 *     'title': '百度',
 *     'hiddenNavigation': false
    })
 */
function openNewWebView(obj) {
    authCheckApp()
        .then(() => {
        // 发起请求
            window.WebViewJavascriptBridge.callHandler('openNewWebView', {
                'url': obj.url,
                'title': obj.title,
                'hiddenNavigation': obj.hiddenNavigation
            }, (response) => {
                return response
            })
        })
}

export default openNewWebView